import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CampusHeader from '../../../components/feature/CampusHeader';
import Footer from '../../../components/feature/Footer';
import { sendPasswordResetCode } from '../../../services/email';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<string | null>(null);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setStatus(null);
    setIsError(false);
    const trimmed = email.trim();
    if (!trimmed) {
      setStatus('Please enter your account email.');
      setIsError(true);
      return;
    }
    setLoading(true);
    try {
      await sendPasswordResetCode(trimmed);
      setStatus('If an account exists for that email, a 6-digit reset code has been sent. Check your inbox (and spam).');
      setTimeout(() => navigate(`/auth/verify-reset-code?email=${encodeURIComponent(trimmed)}`), 1200);
    } catch (err: any) {
      setStatus(err?.message || 'Failed to send reset code.');
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <CampusHeader />
      <main className="max-w-md mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-4 text-center">Forgot Password</h1>
          <p className="text-gray-600 mb-6 text-center">Enter your email and we'll send you a 6-digit reset code.</p>
          <div className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            />
            {status && (
              <p className={`text-sm ${isError ? 'text-red-600' : 'text-green-700'}`}>{status}</p>
            )}
            <button
              onClick={handleSubmit}
              disabled={loading} className="w-full px-4 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors disabled:opacity-60">
                {loading ? 'Sending…' : 'Send reset code'}
              </button>
            <button
              onClick={() => navigate('/auth/sign-in')}
              className="w-full px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Back to Sign In
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;